/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_End_DateInputs */

const en_admin_external_booking_edit_end_date = /** @type {(inputs: Admin_External_Booking_Edit_End_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End date`)
};

const de_admin_external_booking_edit_end_date = /** @type {(inputs: Admin_External_Booking_Edit_End_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enddatum`)
};

const es_admin_external_booking_edit_end_date = /** @type {(inputs: Admin_External_Booking_Edit_End_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de fin`)
};

const fr_admin_external_booking_edit_end_date = /** @type {(inputs: Admin_External_Booking_Edit_End_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date de fin`)
};

/** @type {(inputs: Admin_External_Booking_Edit_End_DateInputs) => LocalizedString} */
const it_admin_external_booking_edit_end_date = en_admin_external_booking_edit_end_date;

/** @type {(inputs: Admin_External_Booking_Edit_End_DateInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_end_date = en_admin_external_booking_edit_end_date;

/** @type {(inputs: Admin_External_Booking_Edit_End_DateInputs) => LocalizedString} */
const pl_admin_external_booking_edit_end_date = en_admin_external_booking_edit_end_date;

/** @type {(inputs: Admin_External_Booking_Edit_End_DateInputs) => LocalizedString} */
const hu_admin_external_booking_edit_end_date = en_admin_external_booking_edit_end_date;

/** @type {(inputs: Admin_External_Booking_Edit_End_DateInputs) => LocalizedString} */
const ro_admin_external_booking_edit_end_date = en_admin_external_booking_edit_end_date;

/**
* | output |
* | --- |
* | "End date" |
*
* @param {Admin_External_Booking_Edit_End_DateInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_end_date = /** @type {((inputs?: Admin_External_Booking_Edit_End_DateInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_End_DateInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_end_date(inputs)
	if (locale === "de") return de_admin_external_booking_edit_end_date(inputs)
	if (locale === "es") return es_admin_external_booking_edit_end_date(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_end_date(inputs)
	if (locale === "it") return it_admin_external_booking_edit_end_date(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_end_date(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_end_date(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_end_date(inputs)
	return ro_admin_external_booking_edit_end_date(inputs)
});
export { admin_external_booking_edit_end_date as "admin.external_booking_edit.end_date" }